import { FolderTreeItem } from "../useQueryFolderTree";

/**
 * Replace a folder node in the tree by its ID with a new folder object.
 * This is used to swap a temporary optimistic folder (e.g. TEMP_FOLDER_ID)
 * with the real folder data returned from the server after creation.
 */
export const replaceFolderInTree = (
  tree: FolderTreeItem[],
  oldFolderId: string,
  newFolder: FolderTreeItem,
): FolderTreeItem[] => {
  return tree.map((folder) => {
    if (String(folder.id) === String(oldFolderId)) {
      return {
        ...newFolder,
        children: newFolder.children ?? folder.children,
      };
    }

    if (folder.children?.length) {
      return {
        ...folder,
        children: replaceFolderInTree(
          folder.children as FolderTreeItem[],
          oldFolderId,
          newFolder,
        ),
      };
    }

    return folder;
  });
};
